module.exports = __webpack_public_path__ + "static/img/AF.e2be7951.svg";